$(function () {
    $('.mobile-menu').click(function () {
       $(this).toggleClass('is-active');
       $('body').toggleClass('mobile-menu-opened');
        updateMobileMenuOffset();
    });

    $('.mobile-nav-wrapper').click(function (e) {
       if(!$(e.target).closest('.mobile-nav-container').length || !$(e.target).closest('header').length){
           $('.mobile-menu').click();
       }
  });

    $('nav.primary li.has-children > a').click(function (e) {
        e.preventDefault();
    });

    $('nav.mobile-primary li.has-children > a').click(function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
        if($(this).parent().hasClass('active')){
            $(this).next().slideDown();
        }else{
            $(this).next().slideUp();
        }
    });


    let headerHeight = $('header').height();
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 200 ) {
            $('body').addClass('on-menu-sticky');
            $('body').css('padding-top', headerHeight + 'px');
        } else {
            $('body').removeClass('on-menu-sticky');
            $('body').css('padding-top', '0px');
        }
        if($('body').hasClass('mobile-menu-opened')){
            updateMobileMenuOffset();
        }
    });


    $('.menu-trigger').click(function () {
        $(this).closest('.nav-container').toggleClass('opened');
    });

    $('.header--quick-assess__search').click(function () {
        $('body').toggleClass('on-search');
        if($('body').hasClass('on-search')){
            $('.header__search-form').slideDown('fast', function () {
                $('.header__search-form input[type=search]').focus();
            });
        }else{
            $('.header__search-form').slideUp('fast');
        }
    });

    $('.header__search-form__close-btn').click(function () {
        $('body').removeClass('on-search');
        $('.header__search-form').slideUp('fast');
    });

});

function updateMobileMenuOffset() {
    var height = $('header').height();
    $('.mobile-nav-wrapper').css({
        'top' : height + 'px',
        'height' : 'calc(100vh - ' + height + 'px)'
    });
}